import styled from 'styled-components';
import {
  flexDirectionColumn,
  layerA,
  scrollbarY,
} from '../styles/commonStyles';
import TransitStation from './transitStation';
import { hpStations } from './stationsData';

const HeatingPlatformMain = () => {
  return (
    <StationWrapper>
      {hpStations.map((station) => (
        <TransitStation key={station.id} data={station} />
      ))}
    </StationWrapper>
  );
};

export default HeatingPlatformMain;
// {
//   /* <Wrapper>
//   <TitleContainer title='heating platform' />
// </Wrapper> */
// }

// const Wrapper = styled.div`

// `;

const StationWrapper = styled.section`
  /* width: 1216px;
  height: auto;
  max-height: 620px; */
  padding: 2px;
  border-radius: 36px 36px 33px 33px;
  /* border-radius: 36px; */

  ${layerA}
  ${flexDirectionColumn} /* ${scrollbarY} */
`;
